module.exports = __webpack_public_path__ + "db860c5e.svg";